import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ENUMS } from '../enums/enums';
import BaseLayout from "../components/layout/BaseLayout/BaseLayout";
import Home from "../components/pages/home/Home";
import Careers from "../components/pages/careers/Careers";
import Contact from "../components/pages/contact/Contact";
import AboutUs from "../components/pages/aboutUs/AboutUs";
import OurPeople from "../components/pages/ourPeople/OurPeople";
import Projects from "../components/pages/projects/Projects";
import Services from "../components/pages/services/Services";
// import Lex from "../components/pages/lex/Lex";
import PageLayout from "../components/layout/PageLayout/PageLayout";
import {useEffect} from "react";
import {useLocation} from "react-router";
import OurPeopleDetail from "../components/pages/ourPeopleDetail/OurPeopleDetail";
import ProjectsDetail from "../components/pages/projectsDetail/ProjectsDetail";
import {useTranslation} from "react-i18next";

const DefaultRouter = () => {
  const { t } = useTranslation();

  return (
    <BrowserRouter>
      <ScrollToTop/>
      <Routes>
        <Route path={ENUMS.ROUTE_HOME} element={<BaseLayout/>}>
          <Route index element={<Home/>} />
          <Route path={ENUMS.ROUTE_ABOUT_US} element={ <PageLayout title={t("aboutUs")}><AboutUs/></PageLayout> } />
          <Route path={ENUMS.ROUTE_SERVICES} element={ <PageLayout title={t("services")}><Services/></PageLayout> } />
          <Route path={ENUMS.ROUTE_OUR_PEOPLE} element={ <PageLayout title={t("ourPeople")}><OurPeople/></PageLayout> } />
          <Route path={`${ENUMS.ROUTE_OUR_PEOPLE}/:id`} element={ <OurPeopleDetail/> } />
          <Route path={ENUMS.ROUTE_PROJECTS} element={ <PageLayout title={t("projects")}><Projects/></PageLayout> } />
          <Route path={`${ENUMS.ROUTE_PROJECTS}/:id`} element={ <ProjectsDetail/> } />
          <Route path={ENUMS.ROUTE_CAREERS} element={ <PageLayout title={t("careers")}><Careers/></PageLayout> } />
          <Route path={ENUMS.ROUTE_CONTACT} element={ <PageLayout title={t("contact")}><Contact/></PageLayout> } />
          {/*<Route path={ENUMS.ROUTE_LEX} element={ <PageLayout title={t("lex")}><Lex/></PageLayout> } />*/}
          <Route path="*" element={ <PageLayout title={t("noPage")}/> } />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default DefaultRouter;
